var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.56847 1.38751H2.41697C2.3497 1.38751 2.28519 1.3671 2.23762 1.33076C2.19005 1.29443 2.16333 1.24514 2.16333 1.19376C2.16333 1.14237 2.19005 1.09309 2.23762 1.05675C2.28519 1.02041 2.3497 1 2.41697 1H7.56847C7.63575 1 7.70026 1.02041 7.74783 1.05675C7.7954 1.09309 7.82212 1.14237 7.82212 1.19376C7.82212 1.24514 7.7954 1.29443 7.74783 1.33076C7.70026 1.3671 7.63575 1.38751 7.56847 1.38751Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.60457 3.50909H1.32689C1.25962 3.50909 1.1951 3.48868 1.14753 3.45234C1.09997 3.41601 1.07324 3.36672 1.07324 3.31534C1.07324 3.26395 1.09997 3.21467 1.14753 3.17833C1.1951 3.142 1.25962 3.12158 1.32689 3.12158H7.60457C7.67184 3.12158 7.73635 3.142 7.78392 3.17833C7.83149 3.21467 7.85821 3.26395 7.85821 3.31534C7.85821 3.36672 7.83149 3.41601 7.78392 3.45234C7.73635 3.48868 7.67184 3.50909 7.60457 3.50909Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 96",
    d: "M3.54545 1C4.60606 1.36458 6.47273 2.64062 5.45455 4.82812C4.43636 7.01562 2.06061 6.46875 1 5.92188L6.09091 9.75",
    stroke: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 97",
    d: "M1 1H8",
    stroke: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 98",
    d: "M1 3.1875H8",
    stroke: "#797979"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupies);
export default __webpack_public_path__ + "static/media/Rupies.5c91064de08d12ee8c4dd1a20f9578f6.svg";
export { ForwardRef as ReactComponent };